/**
 * Judge.me Summary — small custom element that shows live average rating
 *
 * Displays: <score> ★★★★★ <custom text>
 * Score and proportional star fill are pulled from the Judge.me proxy worker's
 * /api/stats endpoint. Falls back to the server-rendered values until JS loads.
 */
class JudgemeSummary extends HTMLElement {
  connectedCallback() {
    this.proxyUrl = this.dataset.proxyUrl;
    if (!this.proxyUrl) return;
    this._load();
  }

  async _load() {
    try {
      const res = await fetch(`${this.proxyUrl}/api/stats`, {
        headers: { 'Accept': 'application/json' },
      });
      if (!res.ok) return;
      const data = await res.json();
      if (typeof data.average_rating !== 'number') return;
      this._update(data.average_rating);
    } catch (err) {
      console.warn('[judgeme-summary] stats fetch failed:', err);
    }
  }

  _update(score) {
    const clamped = Math.max(0, Math.min(5, score));
    const display = clamped.toFixed(1).replace('.', ',');
    const fillPct = (clamped / 5) * 100;

    const scoreEl = this.querySelector('[data-score]');
    const foregroundEl = this.querySelector('[data-stars-foreground]');
    if (scoreEl) scoreEl.textContent = display;
    if (foregroundEl) foregroundEl.style.width = fillPct + '%';
  }
}

if (!window.customElements.get('judgeme-summary')) {
  window.customElements.define('judgeme-summary', JudgemeSummary);
}
